import { ReactComponent as Add } from '../assets/icons/add.svg'
import { ReactComponent as Close } from '../assets/icons/close.svg'
import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { ReactComponent as DownArrow } from '../assets/icons/chevron-down.svg'
import { ReactComponent as CheckMark } from '../assets/icons/checkmark.svg'
import { ReactComponent as Next } from '../assets/icons/next.svg'
import { ReactComponent as Prev } from '../assets/icons/prev.svg'

import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { getCoursesCoverInfo, getCoursesCoverRand, postCourses } from '../apis/course.ts'
import { getSubjects } from '../apis/subject.ts'
import { getMajors } from '../apis/major.ts'
import { useLocation, useNavigate } from 'react-router-dom'
import { getTeachersCourseTime } from '../apis/teacher.ts'
import { dayEnumList } from '../assets/data.js'

export default function ClassAdd() {
  const location = useLocation()
  const navigate = useNavigate()
  // console.log(location.state)
  const [coverInfoList, setCoverInfoList] = useState()
  const [majorList, setMajorList] = useState()
  const [subjectList, setSubjectList] = useState()
  const [courseTimeList, setCourseTimeList] = useState()
  const [hoveredIndex, setHoveredIndex] = useState()
  const [selectedTime, setSelectedTime] = useState([])
  const [selectedCoverInfo, setSelectedCoverInfo] = useState({})

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    resetField,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      subjectId: '',
    },
  })
  useEffect(() => {
    getCoursesCoverInfoApi()
    getCoursesCoverRandApi()
    getMajorsApi()
    getTeachersCourseTimeApi()
    // getSubjectsApi()
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    if (watch('major')) {
      getSubjectsApi(watch('major'))
    }
    resetField('subjectId')
    // eslint-disable-next-line
  }, [watch('major')])

  // useEffect(() => {
  //   if (selectedTime) {
  //     setValue('selectedTime', selectedTime)
  //   }
  // }, selectedTime)

  const dayList = Object.values(dayEnumList).map((day) => day[0])
  const periodList = ['1교시', '2교시', '3교시', '4교시', '5교시', '6교시', '7교시']

  const sortedByList = [
    { id: 1, name: '기본교과', type: 'basicImage' },
    { id: 2, name: '전공', type: 'majorImage' },
  ]
  const [sortedBy, setSortedBy] = useState(1)
  const [hasSelectedTime, setHasSelectedTime] = useState(true)
  const onSubmit = async (data) => {
    if (hasSelectedTime) {
      const postCoursesResponse = await postCourses({
        className: data.className,
        semesterId: location.state.id,
        subjectId: data.subjectId,
        courseTimes: selectedTime,
        imageId: selectedCoverInfo.imageId,
        colorId: selectedCoverInfo.colorId,
      })
      if (postCoursesResponse.error) {
        console.log(postCoursesResponse.message)
        if (postCoursesResponse.error.code === 'E409') {
          setError('className', {
            message:
              '해당 학기의 동일 교과 - 과목 수업에 대해 같은 이름의 분반이 있습니다. 다른 이름으로 설정해주세요.',
          })
        }
        return
      } else {
        console.log(postCoursesResponse.message)
        navigate('/class')
      }
    }
  }
  console.log(errors)

  // const preventClose = (e) => {
  //   e.preventDefault()
  //   // e.returnValue = '' //Chrome에서 동작하도록; deprecated
  // }
  // useEffect(() => {
  //   ;(() => {
  //     window.addEventListener('beforeunload', preventClose)
  //   })()
  //   return () => {
  //     window.removeEventListener('beforeunload', preventClose)
  //   }
  // }, [])

  const getCoursesCoverInfoApi = async () => {
    const getCoursesCoverInfoResponse = await getCoursesCoverInfo()

    if (getCoursesCoverInfoResponse.error) {
      console.log(getCoursesCoverInfoResponse)
      return
    } else {
      setCoverInfoList(getCoursesCoverInfoResponse.data)
    }
  }

  const getCoursesCoverRandApi = async () => {
    const getCoursesCoverRandResponse = await getCoursesCoverRand()

    if (getCoursesCoverRandResponse.error) {
      console.log(getCoursesCoverRandResponse)
      return
    } else {
      setSelectedCoverInfo((prev) => ({
        ...prev,
        backgroundColor: getCoursesCoverRandResponse.data.color.backgroundColor,
        // textColor: getCoursesCoverRandResponse.data.color.textColor,
        colorId: getCoursesCoverRandResponse.data.color.id,
        imageId: getCoursesCoverRandResponse.data.image.id,
        imageUrl: getCoursesCoverRandResponse.data.image.url,
      }))
    }
  }

  const getMajorsApi = async () => {
    const getMajorsResponse = await getMajors()

    if (getMajorsResponse.error) {
      console.log(getMajorsResponse)
      return
    } else {
      setMajorList(getMajorsResponse.data)
    }
  }
  const getSubjectsApi = async (majorId) => {
    const getSubjectsResponse = await getSubjects({
      majorId: majorId,
    })

    if (getSubjectsResponse.error) {
      console.log(getSubjectsResponse)
      return
    } else {
      setSubjectList(getSubjectsResponse.data)
    }
  }
  const getTeachersCourseTimeApi = async () => {
    const getTeachersCourseTimeResponse = await getTeachersCourseTime({
      semesterId: location.state.id,
    })

    if (getTeachersCourseTimeResponse.error) {
      console.log(getTeachersCourseTimeResponse)
      return
    } else {
      setCourseTimeList(getTeachersCourseTimeResponse.data)
    }
  }

  const findItem = (list, id) => {
    const item = list?.find((item) => item.id === id)
    return item
  }
  const deleteItem = (list, setList, index) => {
    const updatedItems = list.filter((_, itemIndex) => itemIndex !== index)
    return setList(updatedItems)
  }

  const getIsDisabledPeriod = (dayItem, periodIndex, timeList) => {
    const dayOfWeekEnum = getDayOfWeekEnum(dayItem)
    if (!dayOfWeekEnum) return false
    const dayData = timeList?.find((item) => item.dayOfWeek === dayOfWeekEnum)
    return dayData && dayData.periods?.includes(periodIndex + 1)
  }

  const getDayOfWeekEnum = (dayItem) => {
    return Object.keys(dayEnumList).find((key) => dayEnumList[key] === dayItem + '요일')
  }

  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    if (Boolean(findItem(coverInfoList?.images['basicImage'], selectedCoverInfo.imageId))) {
      setSortedBy(1)
      if (
        coverInfoList?.images['basicImage'].findIndex(
          (item) => item.id === selectedCoverInfo.imageId,
        ) +
          1 >
        6
      ) {
        setCurrentPage(2)
      } else {
        setCurrentPage(1)
      }
    }
    if (Boolean(findItem(coverInfoList?.images['majorImage'], selectedCoverInfo.imageId))) {
      setSortedBy(2)
      setCurrentPage(1)
    }
    // eslint-disable-next-line
  }, [coverInfoList])

  useEffect(() => {
    if (sortedBy === 2) {
      setCurrentPage(1)
    }
  }, [sortedBy])

  const handleOnInput = (e, maxlength) => {
    const {
      target: { value },
    } = e
    if (value.length > maxlength) e.target.value = value.substr(0, maxlength)
  }
  return (
    <div>
      <div className='mb-40 flex w-full items-center gap-20 border-b-2 border-solid border-border-strong py-8'>
        <p className='text-title2-bold text-label-strong'>수업 추가</p>
        <p className='text-body1-medium text-label-sub'>{location.state.name}</p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='flex items-center justify-center'>
          <div className='flex w-[700px] flex-col items-end justify-center gap-60 rounded-16 border-[1px] border-solid border-border-alternative px-20 py-16'>
            <div className='flex w-full flex-col gap-24'>
              <div className='flex flex-col items-start gap-8'>
                <p className='text-body1-medium text-label-default'>교과/과목</p>
                <div className='flex w-full items-center gap-32'>
                  <div className='flex w-full items-center gap-8'>
                    <div className='relative w-full'>
                      <select
                        {...register('major', {
                          required: '수업 교과 및 과목을 선택해주세요',
                        })}
                        className={`${errors.major ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                      >
                        <option selected disabled value=''>
                          교과 선택
                        </option>
                        {majorList?.map((majorItem, majorIndex) => (
                          <option key={majorIndex} value={majorItem.id}>
                            {majorItem.name}
                          </option>
                        ))}
                      </select>
                      <DownArrow className='pointer-events-none absolute right-16 top-[14px] h-20 w-20 fill-label-default' />
                    </div>
                    <p className='shrink-0 text-body1-regular text-label-default'>교과</p>
                  </div>

                  <div className='flex w-full items-center gap-8'>
                    <div className='relative w-full'>
                      <select
                        {...register('subjectId', {
                          required: '수업 교과 및 과목을 선택해주세요',
                        })}
                        className={`${errors.subjectId ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} select_md peer w-full`}
                        disabled={!Boolean(watch('major'))}
                      >
                        <option disabled selected value=''>
                          과목 선택
                        </option>
                        {subjectList?.map((subjectItem, subjectIndex) => (
                          <option key={subjectIndex} value={subjectItem.id}>
                            {subjectItem.name}
                          </option>
                        ))}
                      </select>
                      <DownArrow className='pointer-events-none absolute right-16 top-[14px] h-20 w-20 cursor-pointer fill-label-default peer-disabled:fill-label-disable' />
                    </div>
                    <p className='shrink-0 text-body1-regular text-label-default'>과목</p>
                  </div>
                </div>
                <span className='text-body3-regular text-status-negative'>
                  {errors?.subjectId?.message}
                </span>
              </div>
              <div className='flex flex-col items-start gap-8'>
                <p className='text-body1-medium text-label-default'>분반 이름</p>
                <div className='relative w-full'>
                  <input
                    {...register('className', {
                      required: '분반 이름을 작성해주세요',
                      maxLength: 20,
                    })}
                    type='text'
                    className={`${errors.className ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                    placeholder='공백 포함 20자 이내'
                    maxLength='20'
                    onInput={(e) => handleOnInput(e, 20)}
                    // defaultValue={location.state.class}
                  />
                  <span className='text-body3-regular text-status-negative'>
                    {errors?.className?.message}
                  </span>
                  {watch('className') && (
                    <button
                      type='button'
                      onClick={() => setValue('className', '')}
                      className='absolute right-16 top-16 cursor-pointer'
                    >
                      <CloseFilled />
                    </button>
                  )}
                </div>
              </div>
              {/* 요일/교시 */}
              <div className='flex flex-col items-start gap-8'>
                <p className='text-body1-medium text-label-default'>요일/교시</p>
                <div className='flex w-full flex-col gap-12'>
                  <div className='grid w-full grid-cols-7 pl-[54px] text-center'>
                    {dayList.map((dayItem, dayIndex) => (
                      <p key={dayIndex} className='text-center text-body3-medium text-label-info'>
                        {dayItem}
                      </p>
                    ))}
                  </div>
                  <div className='flex w-full gap-20'>
                    <div className='grid grid-rows-7 items-center'>
                      {periodList.map((periodItem, periodIndex) => (
                        <p
                          key={periodIndex}
                          className='min-w-[34px] text-center text-body3-medium text-label-info'
                        >
                          {periodItem}
                        </p>
                      ))}
                    </div>
                    <div
                      className={`${hasSelectedTime ? null : 'border border-status-negative'} grid h-full w-full grid-cols-7 rounded-8`}
                    >
                      {dayList.map((dayItem, dayIndex) => {
                        return (
                          <div
                            key={dayIndex}
                            // className='rounded-8 border-solid hover:border-y-[0.5px] hover:border-status-negative first:hover:border-l-[0.5px] first:hover:border-status-negative last:hover:border-r-[0.5px]'
                            // className={`${errors.courseTimes}`}
                          >
                            {periodList.map((periodItem, periodIndex) => {
                              const isDisabledPeriod = getIsDisabledPeriod(
                                dayItem,
                                periodIndex,
                                courseTimeList,
                              )

                              const isSelected = selectedTime.some(
                                (item) =>
                                  item.dayOfWeek === getDayOfWeekEnum(dayItem) &&
                                  item.period === periodIndex + 1,
                              )

                              return (
                                <div
                                  key={periodIndex}
                                  disabled={selectedTime.length > 20}
                                  onClick={() => {
                                    if (
                                      !isDisabledPeriod &&
                                      !isSelected &&
                                      selectedTime.length < 20
                                    ) {
                                      setSelectedTime((prev) => [
                                        ...prev,
                                        {
                                          dayOfWeek: getDayOfWeekEnum(dayItem),
                                          period: periodIndex + 1,
                                        },
                                      ])

                                      setHasSelectedTime(true)
                                    } else if (isSelected) {
                                      setSelectedTime((prev) =>
                                        prev.filter(
                                          (item) =>
                                            item.dayOfWeek !== getDayOfWeekEnum(dayItem) ||
                                            item.period !== periodIndex + 1,
                                        ),
                                      )
                                      // register('courseTimes', { value: selectedTime })
                                    }
                                    // setValue('selectedTime', selectedTime)
                                  }}
                                  onMouseEnter={() =>
                                    setHoveredIndex(
                                      `${getDayOfWeekEnum(dayItem)}-${periodIndex + 1}`,
                                    )
                                  }
                                  onMouseLeave={() => setHoveredIndex(null)}
                                  className={`h-32 border-[0.5px] border-solid ${
                                    isDisabledPeriod
                                      ? 'bg-fill-alternative hover:border-border-active'
                                      : isSelected
                                        ? hoveredIndex ===
                                          `${getDayOfWeekEnum(dayItem)}-${periodIndex + 1}`
                                          ? 'border-border-active bg-primary-hover'
                                          : 'bg-primary-inactive'
                                        : 'cursor-pointer border-border-default bg-background-default hover:border-border-active active:bg-primary-normal'
                                  } ${dayIndex === 0 ? 'first:rounded-tl-8 last:rounded-bl-8' : dayIndex === dayList.length - 1 ? 'first:rounded-tr-8 last:rounded-br-8' : ''}`}
                                />
                              )
                            })}
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
                {selectedTime.length > 0 && (
                  <div className='mt-12 flex flex-wrap items-start gap-12'>
                    {selectedTime.map((item, index) => (
                      <div
                        key={index}
                        className={`${hoveredIndex === `${item.dayOfWeek}-${item.period}` ? 'border-border-active bg-primary-hover fill-static-white text-inverse-label' : 'border-primary-inactive bg-background-secondary text-label-sub'} flex items-center gap-8 rounded-20 border px-12 py-6 text-body2-medium`}
                        onMouseEnter={() => setHoveredIndex(`${item.dayOfWeek}-${item.period}`)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <div className='flex items-center gap-4'>
                          <p>{dayEnumList[item.dayOfWeek]}</p>
                          <div className='h-12 w-[1px] bg-border-default' />
                          <p>{item.period}교시</p>
                        </div>
                        <Close
                          className='cursor-pointer'
                          onClick={() => deleteItem(selectedTime, setSelectedTime, index)}
                        />
                      </div>
                    ))}
                  </div>
                )}
                {!hasSelectedTime && (
                  <p className='mt-12 text-body3-regular text-status-negative'>
                    수업 칸을 하나 이상 선택해주세요
                  </p>
                )}
              </div>
              {/* 커버이미지 */}
              <div className='flex w-full flex-col items-start gap-8'>
                <p className='text-body1-medium text-label-default'>커버이미지</p>
                <div className='flex w-full flex-col items-start gap-16'>
                  <div
                    className='border_default relative h-[200px] w-full rounded-20'
                    style={{
                      backgroundColor: selectedCoverInfo.backgroundColor,
                    }}
                  >
                    <p className='absolute left-50 top-50 text-title1-bold text-label-default'>
                      {findItem(subjectList, watch('subjectId'))
                        ? findItem(subjectList, watch('subjectId')).name
                        : `Example Text`}
                    </p>
                    <img
                      className='absolute right-60 top-0 h-[200px] w-[280px] mix-blend-overlay'
                      src={selectedCoverInfo.imageUrl}
                      alt=''
                    />
                  </div>
                  {/* 일러스트 선택 */}
                  <div className='flex w-full flex-col items-start gap-8'>
                    <p className='text-body2-medium text-label-default'>일러스트 선택</p>
                    <div className='flex w-full justify-between'>
                      <div className='flex items-center gap-4'>
                        {sortedByList.map((item) => (
                          <button
                            key={item.id}
                            type='button'
                            onClick={() => {
                              setSortedBy(item.id)
                            }}
                            className={`${sortedBy === item.id ? 'tag_sm' : 'tag_sm_border'}`}
                          >
                            {item.name}
                          </button>
                        ))}
                      </div>
                      <div className='border_default flex divide-x-[1px] divide-solid divide-border-default rounded-10'>
                        <button
                          type='button'
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          disabled={Boolean(currentPage === 1)}
                          className={`${currentPage === 1 ? 'fill-label-placeholder' : 'fill-label-sub'} flex items-center p-6`}
                        >
                          <Prev />
                        </button>
                        <button
                          type='button'
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          disabled={Boolean(
                            currentPage ===
                              Math.ceil(
                                coverInfoList?.images[
                                  `${sortedBy === 1 ? 'basicImage' : 'majorImage'}`
                                ].length / 6,
                              ),
                          )}
                          className={`${currentPage === Math.ceil(coverInfoList?.images[`${sortedBy === 1 ? 'basicImage' : 'majorImage'}`].length / 6) ? 'fill-label-placeholder' : 'fill-label-sub'} flex items-center p-6`}
                        >
                          <Next />
                        </button>
                      </div>
                    </div>
                    <div className='grid w-full grid-cols-6 items-center gap-8'>
                      {coverInfoList?.images[`${sortedBy === 1 ? 'basicImage' : 'majorImage'}`]
                        .slice((currentPage - 1) * 6, (currentPage - 1) * 6 + 6)
                        .map((imageItem) => (
                          <img
                            key={imageItem.id}
                            onClick={() =>
                              setSelectedCoverInfo((prev) => ({
                                ...prev,
                                imageUrl: imageItem.url,
                                imageId: imageItem.id,
                              }))
                            }
                            className={`object-fit h-[75px] w-100 rounded-8 border-[1px] border-solid px-8 py-[7px] ${imageItem.id === selectedCoverInfo.imageId ? 'border-border-active' : 'border-border-default'}`}
                            src={imageItem.url}
                            alt=''
                          />
                        ))}
                    </div>
                  </div>
                  {/* 배경색 선택 */}
                  <div className='flex w-full flex-col items-start gap-8'>
                    <p className='text-body2-medium text-label-default'>배경색 선택</p>
                    <div className='border_default flex w-full flex-col items-start gap-12 rounded-8 p-12'>
                      <div className='grid grid-cols-6 items-center gap-8'>
                        {coverInfoList?.colors?.map((colorItem, colorIndex) => (
                          <div
                            key={colorIndex}
                            onClick={() =>
                              setSelectedCoverInfo((prev) => ({
                                ...prev,
                                backgroundColor: colorItem.backgroundColor,
                                // textColor: colorItem.textColor,
                                colorId: colorItem.id,
                              }))
                            }
                            className='border_default flex h-48 w-48 items-center justify-center rounded-8 fill-inverse-label'
                            style={{ backgroundColor: colorItem.backgroundColor }}
                          >
                            {colorItem.id === selectedCoverInfo.colorId && (
                              <CheckMark className='h-20 w-20' />
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              onClick={() => {
                if (selectedTime.length === 0) {
                  setHasSelectedTime(false)
                }
              }}
              type='submit'
              className='button_solid_primary_md gap-[5px] fill-inverse-label'
            >
              <Add />
              <p className='text-body2-semibold text-inverse-label'>등록</p>
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}
